import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=b198571c&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b198571c')) {
      api.createRecord('b198571c', component.options)
    } else {
      api.reload('b198571c', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=b198571c&", function () {
      api.rerender('b198571c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2DWSnXmS2WFG3/JS/offershelp.vue"
export default component.exports